import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TokenHeaderComponent } from './token/token-header/token-header.component';
import { AlreadyInTeamComponent } from './token/already-in-team/already-in-team.component';
import { InvalidTokenComponent } from './token/invalid-token/invalid-token.component';
import { ExpiredTokenComponent } from './token/expired-token/expired-token.component';
import { RenewedTokenComponent } from './token/renewed-token/renewed-token.component';
import { AboutYouComponent } from './aboutyou/aboutyou.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamMembersComponent } from './team-members/team-members.component';
import { TeamMembersListComponent } from '../team/team-member/team-members-list/team-members-list.component';
import { ReadyComponent } from './ready/ready.component';
import { OnboardingHeaderComponent } from './onboarding-header/onboarding-header.component';
import { TeamDefaultsSettingsFormComponent } from '../team/team-settings/team-defaults-settings-form/team-defaults-settings-form.component';
import { DefaultSettingsComponent } from './default-settings/default-settings.component';
import { RouterLink } from "@angular/router";
 
@NgModule({
  declarations: [
    OnboardingHeaderComponent,
    TokenHeaderComponent,
    AlreadyInTeamComponent,
    InvalidTokenComponent,
    ExpiredTokenComponent,
    RenewedTokenComponent,
    AboutYouComponent,
    DefaultSettingsComponent,
    TeamMembersComponent,
    ReadyComponent
  ],
  imports: [
    TeamDefaultsSettingsFormComponent,
    TeamMembersListComponent,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
  ]
})
export class TmOnboardingModule{
}